export default __webpack_public_path__ + "static/media/xum-logo.c6d044ec.png";